import { configureStore } from "@reduxjs/toolkit";
import { AuthApi } from "../utils/api/auth/auth.api";
import { UserSlice } from "./slice/User.slice";
import { UserApi } from "../utils/api/user/user.api";
import { currentEnv, Env } from "../utils/http";
import { ClassApi } from "../utils/api/classe/classe.api";
import { MatiereApi } from "../utils/api/matiere/matiere.api";
import { CompetenceApi } from "../utils/api/competence/competence.api";
import { DevoirApi } from "../utils/api/devoir/devoir.api";
import { AbsenceApi } from "../utils/api/absence/absence.api";
import { EvaluationApi } from "../utils/api/evaluations/evaluation.api";
import { ObjectifApi } from "../utils/api/objectif/objectif.api";
import { MessageApi } from "../utils/api/message/message.api";
import { BulletinApi } from "../utils/api/bulletin/bulletin.api";
import { CompetenceStudentApi } from "../utils/api/competenceStudent/competenceStudent.api";
import { ObjectifStudentApi } from "../utils/api/objectifStudent/objectifStudent.api";
import { PolicyApi } from "../utils/api/policy/policy.api";
import { PlanApi } from "../utils/api/plan/plan.api";
import { SubscriptionApi } from "../utils/api/subscription/subscription.api";
import { PaymentApi } from "../utils/api/payment/payment.api";
import { OptionApi } from "../utils/api/option/option.api";
import { subscriptionSlice } from "./slice/subscription.slice";
import { FactureApi } from "../utils/api/facture/facture.api";
import { DevoirStudentApi } from "../utils/api/devoirStudent/devoirStudent.api";
import { NotificationApi } from "../utils/api/notification/notification.api";
import { PaymentFactureApi } from "../utils/api/paymentFacture/paymentFacture.api";
import { SupportApi } from "../utils/api/support/support.api";
import { ChildSlice } from "./slice/child.slice";
import { ObservationApi } from "../utils/api/observation/observation.api";
import {DashboardApi} from "../utils/api/dashboard/dashboard.api"
import { ActivityApi } from "../utils/api/activity/activity.api";


const store = configureStore({
  reducer: {
    [AuthApi.reducerPath]: AuthApi.reducer,
    [UserSlice.name]: UserSlice.reducer,
    [subscriptionSlice.name]: subscriptionSlice.reducer,
    [ChildSlice.name]: ChildSlice.reducer,
    [UserApi.reducerPath]: UserApi.reducer,
    [ClassApi.reducerPath]: ClassApi.reducer,
    [MatiereApi.reducerPath]: MatiereApi.reducer,
    [CompetenceApi.reducerPath]: CompetenceApi.reducer,
    [DevoirApi.reducerPath]: DevoirApi.reducer,
    [DevoirStudentApi.reducerPath]: DevoirStudentApi.reducer,
    [AbsenceApi.reducerPath]: AbsenceApi.reducer,
    [EvaluationApi.reducerPath]: EvaluationApi.reducer,
    [ObjectifApi.reducerPath]: ObjectifApi.reducer,
    [MessageApi.reducerPath]: MessageApi.reducer,
    [BulletinApi.reducerPath]: BulletinApi.reducer,
    [CompetenceStudentApi.reducerPath]: CompetenceStudentApi.reducer,
    [ObjectifStudentApi.reducerPath]: ObjectifStudentApi.reducer,
    [PolicyApi.reducerPath]: PolicyApi.reducer,
    [OptionApi.reducerPath]: OptionApi.reducer,
    [PlanApi.reducerPath]: PlanApi.reducer,
    [SubscriptionApi.reducerPath]: SubscriptionApi.reducer,
    [PaymentApi.reducerPath]: PaymentApi.reducer,
    [FactureApi.reducerPath]: FactureApi.reducer,
    [NotificationApi.reducerPath]: NotificationApi.reducer,
    [PaymentFactureApi.reducerPath]: PaymentFactureApi.reducer,
    [SupportApi.reducerPath]: SupportApi.reducer,
    [ObservationApi.reducerPath]: ObservationApi.reducer,
    [DashboardApi.reducerPath]: DashboardApi.reducer,
    [ActivityApi.reducerPath]: ActivityApi.reducer,
  },
  devTools: Env === currentEnv,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      AuthApi.middleware,
      UserApi.middleware,
      ClassApi.middleware,
      MatiereApi.middleware,
      CompetenceApi.middleware,
      DevoirApi.middleware,
      DevoirStudentApi.middleware,
      AbsenceApi.middleware,
      EvaluationApi.middleware,
      ObjectifApi.middleware,
      MessageApi.middleware,
      BulletinApi.middleware,
      CompetenceStudentApi.middleware,
      ObjectifStudentApi.middleware,
      PolicyApi.middleware,
      OptionApi.middleware,
      PlanApi.middleware,
      SubscriptionApi.middleware,
      PaymentApi.middleware,
      FactureApi.middleware,
      NotificationApi.middleware,
      PaymentFactureApi.middleware,
      SupportApi.middleware,
      ObservationApi.middleware,
      DashboardApi.middleware,
      ActivityApi.middleware
    ),
});

export type AppDispatch = typeof store.dispatch;

export type RootState = ReturnType<typeof store.getState>;

export default store;
